export const columns = [
  // {title: '批次号', key: 'pkgCode', dataIndex: 'pkgCode'},
  {
    title: "商品图片",
    key: "productImg",
    dataIndex: "productImg",
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  { title: "商品名称", key: "productName", dataIndex: "productName" },
  {
    title: "批次包编号",
    key: "pkgCodeList",
    dataIndex: "pkgCodeList",
    scopedSlots: {
      customRender: "pkgCodeList",
    },
  },
  {
    title: "FNSKU",
    key: "amazonFnsku",
    dataIndex: "amazonFnsku",
    customRender: (text, record) => {
      return record.amazonFnsku || record.coding;
    },
  },
  {
    title: "数量",
    key: "deliveryNums",
    dataIndex: "deliveryNums",
  },
  {
    title: "需打印数量",
    key: "printAmount",
    dataIndex: "printAmount",
    scopedSlots: {
      customRender: "printAmountAction",
    },
  },
  {
    title: "打印标签",
    key: "id",
    dataIndex: "id",
    scopedSlots: {
      customRender: "action",
    },
  },
];
